import { useState, useEffect } from "react";
import Common from "../common/Common";

const Modal = ({ isOpen, onClose, selectedDate, onSave, isPlan }) => {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [type, setType] = useState("task");
  const [goal, setGoal] = useState("");
  const [fromTime, setFromTime] = useState("");
  const [toTime, setToTime] = useState("");
  const [task, setTask] = useState("");
  const [resources, setResources] = useState([]);
  const [newResource, setNewResource] = useState({ name: "", link: "" });
  const [isEditingResources, setIsEditingResources] = useState(false);

  // Update state when `selectedDate` changes
  useEffect(() => {
    if (selectedDate) {
      const date = selectedDate.split("T")[0];
      const time = selectedDate.split("T")[1]?.split("+")[0] || "";
      setFromDate(date);
      setToDate(date);
      setFromTime(time);
      setToTime(time);
    }
  }, [selectedDate]);

  const saveTask = async (e) => {
    if (isPlan != "" && isPlan != undefined) {
      setType("Plan");
      setGoal(isPlan);
    }
    e.preventDefault();
    let color = Common();
    const newTask = {
      title: task,
      start: `${fromDate}T${fromTime}`,
      end: `${fromDate}T${toTime}`,
      backgroundColor: color,
      resources:resources,
      textColor: "black",
    };
    const saveTask = {
      title: task,
      type: type,
      goal: isPlan,
      resources: resources,
      start: `${fromDate}T${fromTime}`,
      end: `${fromDate}T${toTime}`,
      date: fromDate,
    };
    let res = await fetch(`${process.env.REACT_APP_NODEURL}/createTask`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(saveTask),
    });
    let ans = await res.json();
    if (ans.msg == "success") {
      if (isPlan != "" && isPlan!=undefined) {
        onSave(ans.res);
      } else {
        onSave(newTask);
      }
    }
  };

  const handleResourceChange = (index, field, value) => {
    const updated = [...resources];
    updated[index][field] = value;
    setResources(updated);
  };

  const handleAddResource = () => {
    const trimmedName = newResource.name.trim();
    const trimmedLink = newResource.link.trim();
    if (trimmedName && trimmedLink) {
      setResources([...resources, { name: trimmedName, link: trimmedLink }]);
      setNewResource({ name: "", link: "" });
    }
  };

  const handleDeleteResource = (index) => {
    const updated = [...resources];
    updated.splice(index, 1);
    setResources(updated);
  };

  const getSuggestion = async(tasks)=>{
    let prompt=
    `
    You are an AI assistant that gives resources name and link for given task.

Task: ${tasks}

Instructions:
1. Link should be relevant and workable and youtube links should be WORKABLE 
2. Return only  List in json given in example format RAW JSON FORMAT
3. Give resources only if task is valid. Else return ERROR

Example format: 
{
json:
[
{ name:"",
 link:""
 }
 ]
 }

  `;
    // https://aiplanner-civ5.onrender.com
    let res = await fetch("https://aiplanner-kp43.onrender.com/ask", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify({
        prompt: prompt,
      }),
    });
    let result = await res.json();
    if (result && result.response) {
      let content = JSON.parse(result.response).choices[0].message.content;
      if (content.startsWith("```")) {
        content = content.replace(/```(?:json)?/i, "").trim();
        content = content.replace(/```$/, "").trim();
      }
      let links=JSON.parse(content).json
      setResources(links)
      console.log(newResource,links)
    } else {
      console.error("Invalid response from API: ", result);
    }
  }

  if (!isOpen) return null; // Don't render if modal is closed

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 backdrop-blur-sm bg-black/70">
      <div className="bg-[#0f0f1a] p-6 rounded-xl border border-purple-900/50 shadow-2xl w-full max-w-md">
        <h2 className="text-xl font-semibold text-purple-300/90 mb-4 tracking-wide text-left">
          Create New Task
        </h2>
        <form className="space-y-4">
          {/* Task Name */}
          <div className="text-left">
            <label className="block text-xs font-medium text-purple-300/80 mb-2 tracking-wider uppercase">
              Task Name
            </label>
            <input
              type="text"
              onChange={(e) => setTask(e.target.value)} onBlur={(e)=>getSuggestion(e.target.value)}
              className="w-full p-3 text-sm rounded-lg bg-[#161622] text-purple-100 border border-purple-900/50 focus:outline-none focus:ring-1 focus:ring-purple-500/50 focus:border-purple-500/50 placeholder-purple-100/70"
              placeholder="Enter task name"
            />
          </div>

          {/* Date and Time Fields */}
          <div className="grid grid-cols-2 gap-4 text-left">
            {/* Date Field */}
            <div>
              <label className="block text-xs font-medium text-purple-300/80 mb-2 tracking-wider uppercase">
                Date
              </label>
              <input
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                className="w-full p-3 text-sm rounded-lg bg-[#161622] text-purple-100 border border-purple-900/50 focus:outline-none focus:ring-1 focus:ring-purple-500/50 focus:border-purple-500/50"
              />
            </div>

            {/* Start Time Field */}
            <div>
              <label className="block text-xs font-medium text-purple-300/80 mb-2 tracking-wider uppercase">
                Start Time
              </label>
              <input
                type="time"
                value={fromTime}
                onChange={(e) => setFromTime(e.target.value)}
                className="w-full p-3 text-sm rounded-lg bg-[#161622] text-purple-100 border border-purple-900/50 focus:outline-none focus:ring-1 focus:ring-purple-500/50 focus:border-purple-500/50"
              />
            </div>
          </div>

          {/* End Time Field */}
          <div className="text-left">
            <label className="block text-xs font-medium text-purple-300/80 mb-2 tracking-wider uppercase">
              End Time
            </label>
            <input
              type="time"
              value={toTime}
              onChange={(e) => setToTime(e.target.value)}
              className="w-full p-3 text-sm rounded-lg bg-[#161622] text-purple-100 border border-purple-900/50 focus:outline-none focus:ring-1 focus:ring-purple-500/50 focus:border-purple-500/50"
            />
          </div>

          {/* Resources */}
          <div className="text-left">
            <div className="flex items-center justify-between mb-2">
              <span className="text-xs font-medium text-purple-300/80 tracking-wider uppercase">
                Resources
              </span>
              {resources.length > 0 && (
                <button   type="button"
                  className="text-xs text-purple-400/80 hover:text-purple-300 transition-colors"
                  onClick={() => setIsEditingResources((prev) => !prev)}
                >
                  {isEditingResources ? "Done" : "Edit"}
                </button>
              )}
            </div>

            <ul className="space-y-2.5">
              {resources.map((item, index) => (
                <li key={index} className="flex items-center gap-2">
                  {isEditingResources ? (
                    <div className="flex items-center gap-2 w-full">
                      <input
                        type="text"
                        value={item.name}
                        onChange={(e) =>
                          handleResourceChange(index, "name", e.target.value)
                        }
                        className="flex-1 p-2 text-sm rounded bg-[#161622] text-purple-100 border border-purple-900/50 focus:outline-none focus:ring-1 focus:ring-purple-500/50 focus:border-purple-500/50"
                        placeholder="Resource name"
                      />
                      <input
                        type="text"
                        value={item.link}
                        onChange={(e) =>
                          handleResourceChange(index, "link", e.target.value)
                        }
                        className="flex-1 p-2 text-sm rounded bg-[#161622] text-purple-100 border border-purple-900/50 focus:outline-none focus:ring-1 focus:ring-purple-500/50 focus:border-purple-500/50"
                        placeholder="https://"
                      />
                      <button
                        className="p-2 text-purple-500/70 hover:text-red-400 transition-colors"
                        onClick={() => handleDeleteResource(index)}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-4 w-4"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                          />
                        </svg>
                      </button>
                    </div>
                  ) : (
                    <a
                      href={item.link}
                      className="text-sm text-purple-400/90 hover:text-purple-300 transition-colors flex items-center gap-1.5"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
                        />
                      </svg>
                      <span className="truncate max-w-xs">{item.name}</span>
                    </a>
                  )}
                </li>
              ))}
            </ul>

            {/* Add new resource */}
            <div className="flex gap-2 mt-3">
              <input
                type="text"
                value={newResource.name}
                onChange={(e) =>
                  setNewResource({ ...newResource, name: e.target.value })
                }
                className="flex-1 p-2 text-sm rounded bg-[#161622] text-purple-100 border border-purple-900/50 focus:outline-none focus:ring-1 focus:ring-purple-500/50 focus:border-purple-500/50"
                placeholder="Resource name"
              />
              <input
                type="text"
                value={newResource.link}
                onChange={(e) =>
                  setNewResource({ ...newResource, link: e.target.value })
                }
                className="flex-1 p-2 text-sm rounded bg-[#161622] text-purple-100 border border-purple-900/50 focus:outline-none focus:ring-1 focus:ring-purple-500/50 focus:border-purple-500/50"
                placeholder="https://"
              />
              <button
                className={`p-2 rounded transition-colors ${
                  newResource.name.trim() && newResource.link.trim()
                    ? "text-purple-400/90 hover:text-purple-300 hover:bg-purple-900/20"
                    : "text-purple-900/50 cursor-not-allowed"
                }`}
                onClick={handleAddResource}
                disabled={!newResource.name.trim() || !newResource.link.trim()}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                  />
                </svg>
              </button>
            </div>
          </div>

          {/* Buttons */}
          <div className="flex justify-end gap-3 pt-4">
            <button
              onClick={onClose}
              type="button"
              className="px-4 py-2 text-sm rounded-md text-purple-300/90 hover:text-purple-200 hover:bg-red-900/30 transition-colors border border-red-900/50"
            >
              Cancel
            </button>
            <button
              onClick={saveTask}
              type="button"
              className="px-4 py-2 text-sm rounded-md bg-purple-900/60 text-purple-100 hover:bg-purple-800/60 transition-colors border border-purple-800/50 shadow-[0_1px_1px_0px_rgba(139,92,246,0.2)]"
            >
              Create Task
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Modal;
